import { Route } from "react-router-dom";

export const testsRoutes = (
    <>
        <Route path="/forms" element={<p>Fiche d’engagement</p>} key="test" />
    </>
);
